export default __webpack_public_path__ + "22dcf0d60982b82e57ee948029d828ff.jpg";